<template>
  <v-container v-if="!activeItem">
      <h3>Loading...</h3>
  </v-container>
  <v-container v-else>
    <div v-if="activeItem.type === 'none'">
      <h4> There are currently no new annotations to review. </h4>
    </div>
    <div v-else>
      <div> Annotations presented to you: {{ active + 1 }}</div>
      <div> Estimated annotations available for review: {{ activeItem.available_annotations }} </div>
      <h1 class="label-name">{{activeItem.attributes.name}}</h1>
      <div v-if="isImageReview">
        <h2 class="message"> Full Image Review </h2>
      </div>
      <div v-else>
      </div>
      <div v-if="isImageReview" class="text-center mt-3">Correct image</div>
      <div v-else class="text-center mt-3">Correct area</div>
      <v-layout justify-center class="mb-3">
        <v-btn
          block
          :dark="review.correct_area !== false"
          :outline="review.correct_area !== false"
          class="mx-1"
          @click="review.correct_area = false; review.grade_value=null"
        >No</v-btn>
        <v-btn
          block
          :dark="review.correct_area !== true"
          :outline="review.correct_area !== true"
          class="mx-1"
          @click="review.correct_area = true"
        >Yes</v-btn>
      </v-layout>
      <div class="canvas-wrapper">
        <canvas
          class="areaOfInterestCanvas"
          id="areaOfInterestCanvas">
        </canvas>
      </div>
      <div v-if="review.correct_area">
        <div class="text-center mt-3">{{ activeItem.attributes.grade_title }} of {{ activeItem.attributes.name }}</div>

        <v-layout justify-center class="mb-3">
          <Grade :grade_scale="this.activeItem.attributes.grade_scale" class="dark" v-model="review.grade_value"/>
        </v-layout>
      </div>
      <v-btn block @click="saveAndNext()" :disabled="!isValid">Next</v-btn>
      <p> Image: </p>
      <div class="image-wrapper">
        <img
          class="image" id="image" crossorigin="anonymous"
          :src="activeItem.attributes.image_url"
          :key="activeItemKey"
          ref="image"
          @load="onImageLoad"
        >
        <Canvas
          class="canvas"
          id="canvas"
          v-if="showCanvas"
          :polygones="activeItemPolygones"
          :focalpoints="activeItemScreening"
          :image="$refs.image"
        />
      </div>
    </div>
  </v-container>
</template>


<script>
import { mapActions, mapState, mapMutations } from 'vuex'

import Grade from '@/components/review/Grade'
import Canvas from '@/components/review/canvas/Canvas'
import { cloneDeep } from 'lodash'
import rgba from '@/helpers/rgba'

let DEFAULT_LOOK_AHEAD = 5;

let keyCode = { "Backspace": 8, "Tab": 9, "Enter": 13, "Shift": 16, "Ctrl": 17, "Alt": 18, "Pause/Break": 19, "Caps Lock": 20, "Esc": 27, "Space": 32, "Page Up": 33, "Page Down": 34, "End": 35, "Home": 36, "Left": 37, "Up": 38, "Right": 39, "Down": 40, "Insert": 45, "Delete": 46, "0": 48, "1": 49, "2": 50, "3": 51, "4": 52, "5": 53, "6": 54, "7": 55, "8": 56, "9": 57, "A": 65, "B": 66, "C": 67, "D": 68, "E": 69, "F": 70, "G": 71, "H": 72, "I": 73, "J": 74, "K": 75, "L": 76, "M": 77, "N": 78, "O": 79, "P": 80, "Q": 81, "R": 82, "S": 83, "T": 84, "U": 85, "V": 86, "W": 87, "X": 88, "Y": 89, "Z": 90, "Windows": 91, "Right Click": 93, "Numpad 0": 96, "Numpad 1": 97, "Numpad 2": 98, "Numpad 3": 99, "Numpad 4": 100, "Numpad 5": 101, "Numpad 6": 102, "Numpad 7": 103, "Numpad 8": 104, "Numpad 9": 105, "Numpad *": 106, "Numpad +": 107, "Numpad -": 109, "Numpad .": 110, "Numpad /": 111, "F1": 112, "F2": 113, "F3": 114, "F4": 115, "F5": 116, "F6": 117, "F7": 118, "F8": 119, "F9": 120, "F10": 121, "F11": 122, "F12": 123, "Num Lock": 144, "Scroll Lock": 145, "My Computer": 182, "My Calculator": 183, ";": 186, "=": 187, ",": 188, "-": 189, ".": 190, "/": 191, "`": 192, "[": 219, "\\": 220, "]": 221, "'": 222 };
var canGet; // boolean, used to stop multiple get request in a row
var coordinates_x_factor; // used to scale x coordinates if image is resized compared to original
var coordinates_y_factor; // used to scale y coordinates if image is resized compared to original
export default {
  components: { Canvas, Grade },
  data() {
    return {
      type: 'reviews',
      active: 0,
      showCanvas: false,
      review: {
        correct_area: true,
        grade_value: null,
      },
      keyCode: { "Backspace": 8, "Tab": 9, "Enter": 13, "Shift": 16, "Ctrl": 17, "Alt": 18, "Pause/Break": 19, "Caps Lock": 20, "Esc": 27, "Space": 32, "Page Up": 33, "Page Down": 34, "End": 35, "Home": 36, "Left": 37, "Up": 38, "Right": 39, "Down": 40, "Insert": 45, "Delete": 46, "0": 48, "1": 49, "2": 50, "3": 51, "4": 52, "5": 53, "6": 54, "7": 55, "8": 56, "9": 57, "A": 65, "B": 66, "C": 67, "D": 68, "E": 69, "F": 70, "G": 71, "H": 72, "I": 73, "J": 74, "K": 75, "L": 76, "M": 77, "N": 78, "O": 79, "P": 80, "Q": 81, "R": 82, "S": 83, "T": 84, "U": 85, "V": 86, "W": 87, "X": 88, "Y": 89, "Z": 90, "Windows": 91, "Right Click": 93, "Numpad 0": 96, "Numpad 1": 97, "Numpad 2": 98, "Numpad 3": 99, "Numpad 4": 100, "Numpad 5": 101, "Numpad 6": 102, "Numpad 7": 103, "Numpad 8": 104, "Numpad 9": 105, "Numpad *": 106, "Numpad +": 107, "Numpad -": 109, "Numpad .": 110, "Numpad /": 111, "F1": 112, "F2": 113, "F3": 114, "F4": 115, "F5": 116, "F6": 117, "F7": 118, "F8": 119, "F9": 120, "F10": 121, "F11": 122, "F12": 123, "Num Lock": 144, "Scroll Lock": 145, "My Computer": 182, "My Calculator": 183, ";": 186, "=": 187, ",": 188, "-": 189, ".": 190, "/": 191, "`": 192, "[": 219, "\\": 220, "]": 221, "'": 222 },
      isSubmitting: false,
    }
  },
  computed: {
    activeItem() {
      let item = cloneDeep(this.data[this.active]);
      return item;
    },
    activeItemKey() {
      let key = this.active;
      return key;
    },
    isImageReview(){
      return (this.activeItem.attributes.annotation_type === 'image_annotations' || this.activeItem.attributes.annotation_type === 'ImageAnnotation');
    },
    activeItemPolygones() {
      var coords = this.activeItem.attributes.coordinates
        .split(';')
        .map(str => str.split(','))
        .map(([x, y]) => ({ x, y }))
      var c;
      for (c of coords) {
        c['x'] = c['x']*coordinates_x_factor;
        c['y'] = c['y']*coordinates_y_factor;
      }
      return [{
        coords,
        color: rgba(),
      }];
    },
    activeItemScreening() {
      if (this.activeItem.attributes.radius == 0) { return [] }
      return [];
    },
    isValid() {
      if (this.review.grade_value !== null || !this.review.correct_area) {
        return true;
      } else {
        return false;
      }
    },
    ...mapState({
      data: state => state.currentPage.data,
    }),
  },
  methods: {
    ...mapMutations('currentPage', ['prev']),
    ...mapActions('currentPage', ['get', 'submit', 'resetReviews']),

    async next() {
      this.showCanvas = false;
      this.active = this.active + 1;
      this.clearAreaOfInterest();
      if (this.active + DEFAULT_LOOK_AHEAD >= this.data.length && canGet) {
        this.get(this.$route.params.uuid);
        canGet = false;
      }
      if (this.active + DEFAULT_LOOK_AHEAD < this.data.length && !canGet) {
        canGet = true;
      }
    },
    async save() {
      const _activeItem = JSON.parse(JSON.stringify(this.activeItem));
      const _review = JSON.parse(JSON.stringify(this.review));
      let payload = {
        "data": {
          "type": "reviews",
          "attributes": {
            "correct_area": null,
            "grade_value": null,
            "grade_scale": _activeItem.attributes.grade_scale,
            "grade_scale_uuid": _activeItem.attributes.grade_scale_uuid, // NOTE: grade_scale_uuid = scale_config (2 different api endpoints is served with different naming)
            "scale_config": _activeItem.attributes.scale_config,
            "is_grade_review": true,
            ..._review,  // This overrides *relevant* default values
          },
          "relationships": {
            "annotation": {
              "data": {
                "type": "annotations",
                "id": _activeItem.id
              }
            }
          }
        }
      };
      if (this.isValid) {
        this.submit({data: payload});
        this.next();
      }
    },
    async saveAndNext(){
      if (this.isSubmitting){
        return;
      }
      try {
        this.isSubmitting = true;
        await this.save();
      } finally {
        this.isSubmitting = false;
      }
    },
    bindHotkeys: function () {
      let self = this;

      document.onkeyup = function (e) {
        if (e.which === keyCode['A']) {
            self.review.correct_area = false;
            self.review.grade_value = null;
        }
        if (e.which === keyCode['S']) {
            self.review.correct_area = true;
        }
        if (e.which === keyCode['Enter']) {
            if (self.isValid) {
              self.saveAndNext();
            }
        }
        if (  e.which === keyCode['0']
              && self.review.correct_area
              && JSON.parse(self.activeItem.attributes.grade_scale).includes(0)) {
          self.review.grade_value = 0;
        }
        if (  e.which === keyCode['1']
              && self.review.correct_area
              && JSON.parse(self.activeItem.attributes.grade_scale).includes(1)) {
          self.review.grade_value = 1;
        }
        if (  e.which === keyCode['2']
              && self.review.correct_area
              && JSON.parse(self.activeItem.attributes.grade_scale).includes(2)) {
          self.review.grade_value = 2;
        }
        if (  e.which === keyCode['3']
              && self.review.correct_area
              && JSON.parse(self.activeItem.attributes.grade_scale).includes(3)) {
          self.review.grade_value = 3;
        }
      }
    },
    async onImageLoad() {
      this.respond_to_annotation_type();
      this.set_coordinates_factors();
      this.showCanvas = true;
      this.drawAreaOfInterest();

    },
    respond_to_annotation_type(){
      // logic if annotation is image annotation
      if (this.isImageReview){
        const img = document.getElementById('image');
        const img_width = img.naturalWidth;
        const img_height = img.naturalHeight;
        const orig_image_width = this.activeItem.attributes.orig_image_width;
        const orig_image_height = this.activeItem.attributes.orig_image_height;

        var c0,c1,c2,c3;

        if (img_width > img_height && orig_image_width > orig_image_height){
          c0 = '10.0,10.0';
          c1 = '10.0,' + (orig_image_height - 10).toString(10);
          c2 = (orig_image_width - 10).toString(10) + ',' + (orig_image_height - 10).toString(10);
          c3 = (orig_image_width - 10).toString(10) + ',' + '10.0';
                  }
        else if (img_width < img_height && orig_image_width < orig_image_height) {
          c0 = '10.0,10.0';
          c1 = '10.0,' + (orig_image_height - 10).toString(10);
          c2 = (orig_image_width - 10).toString(10) + ',' + (orig_image_height - 10).toString(10);
          c3 = (orig_image_width - 10).toString(10) + ',' + '10.0';
        }
        else{
          c0 = '10.0,10.0';
          c1 = '10.0,' + (orig_image_width - 10).toString(10);
          c2 = (orig_image_height - 10).toString(10) + ',' + (orig_image_width - 10).toString(10);
          c3 = (orig_image_height - 10).toString(10) + ',' + '10.0';
        }
        this.activeItem.attributes.coordinates = c0+';'+c1+';'+c2+';'+c3;
      }
    },
    async set_coordinates_factors(){
      // the image can be resized compared to original image & coordinates, which
      // needs to be addressed by a scaling factor on the coordinates
      var img = document.getElementById("image");
      const img_width = img.naturalWidth;
      const img_height = img.naturalHeight;
      const orig_image_width = this.activeItem.attributes.orig_image_width;
      const orig_image_height = this.activeItem.attributes.orig_image_height;

      if (img_width > img_height && orig_image_width > orig_image_height){
        coordinates_x_factor = img_width / orig_image_width;
        coordinates_y_factor = img_height / orig_image_height;
      }
      else if (img_width < img_height && orig_image_width < orig_image_height) {
        coordinates_x_factor = img_width / orig_image_width;
        coordinates_y_factor = img_height / orig_image_height;
      }
      else{
          coordinates_x_factor = img_width / orig_image_height;
          coordinates_y_factor = img_height / orig_image_width;
      }
    },
    drawAreaOfInterest() {
      var img = document.getElementById("image");

      var patch_canvas = document.getElementById("areaOfInterestCanvas");
      var patch_ctx = patch_canvas.getContext("2d");

      if (this.isImageReview){
        return;
      }

      const coords = this.activeItem.attributes.coordinates
        .split(';')
        .map(str => str.split(','))
        .map(([x, y]) => ({ x, y }));

      var xs = [];
      var ys = [];
      var c;
      for (c of coords) {
        xs.push(c['x']*coordinates_x_factor);
        ys.push(c['y']*coordinates_y_factor);
      }
      var xmax = Math.max(...xs);
      var xmin = Math.min(...xs);
      var ymax = Math.max(...ys);
      var ymin = Math.min(...ys);
      var width = xmax - xmin;
      var height = ymax - ymin;
      var side_length = Math.max(Math.max(width, height), 100);

      var width_padding = (side_length - width) / 2;
      var height_padding = (side_length - height) / 2;

      // source images values
      var sx = Math.max(xmin-width_padding, 0);
      var sy = Math.max(ymin-height_padding, 0);
      var sWidth = width + 2*width_padding;
      var sHeight = height + 2*height_padding;

      // destination images values
      var dx = 0;
      var dy = 0;
      var dWidth = sWidth;
      var dHeight = sHeight;
      patch_canvas.height = dHeight;
      patch_canvas.width = dWidth;
      patch_ctx.drawImage(img, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);

    },
      async clearAreaOfInterest() {
        var canvas = document.getElementById("areaOfInterestCanvas");
        var ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        canvas.width = 0;
        canvas.height = 0;
    },
  },
  created() {
    this.resetReviews();
    this.get(this.$route.params.uuid);
    this.bindHotkeys();
  },
  watch: {
    type() {
      this.review = {
        correct_area: true,
        grade_value: null,
      };
    },
    active() {
      this.review = {
        correct_area: true,
        grade_value: null,
      };
    }
  }
}
</script>


<style lang="scss" scoped>
.image-wrapper {
  position: relative;
}

.image {
  width: 100%;
  image-orientation: from-image;
}

.canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.canvas-wrapper {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  text-align: center;
}

.areaOfInterestCanvas {
  max-width: 50%;
  max-height: 50%;
}

.label-name {
  text-align: center;
}

.message {
  text-align: center;
}
</style>